import React from "react";

export default function Loader({ message = "Loading...", variant = "overlay" }) {
  const isFullscreen = variant === "fullscreen";
  return (
    <div
      className={`loading-overlay ${isFullscreen ? "fullscreen" : "overlay"}`}
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="loading-card">
        <div className="spinner" />
        <div className="loading-text">{message}</div>
        <div className="loading-subtext">This may take a few seconds…</div>
      </div>
    </div>
  );
}
